var fitt = require('fitt'),
fs = require('fs'),
path = require('path');

module.exports = function (config, response) {
    var writePath = config && config.path,
    callback = config && config.callback,
    dirname = path.dirname(writePath);

    if (!fs.existsSync(dirname)) {
        fs.mkdirSync(path.resolve(dirname));
    }

    if (fitt.isObj(response)) {
        response = JSON.stringify(response);
    }

    // async write to disk
    fs.writeFile(writePath, response, function (err) {
        if (err) {
            console.log('fitt-http write error');
        }
        callback && callback(err, writePath, response);
    });
};


//////////////////
// WEBPACK FOOTER
// ../~/espn-fitt/es5/fitt-http/core/fileWriter.js
// module id = 823
// module chunks = 0